import { render, staticRenderFns } from "./DecimalEditor.vue?vue&type=template&id=c927f1f0&"
import script from "./DecimalEditor.vue?vue&type=script&lang=js&"
export * from "./DecimalEditor.vue?vue&type=script&lang=js&"
import style0 from "./DecimalEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports